import styles from './MenuDivider.module.scss';

import { Divider } from '@mui/material';

export const MenuDivider = () => {
  return <Divider className={styles.divider} />;
};
